exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.max-width-65 {\n  max-width: 65%;\n}\n", ""]);

// exports
